import React, { useEffect, useState } from "react";
import { EuiFormRow, EuiSelect } from "@elastic/eui";
import _ from "lodash";
import { useIntl, FormattedDate } from "react-intl";

function AbstractSelect({
    options,
    entityObject,
    errors,
    register,
    onChange,
    compressed,
    isLoading,
}) {
    const selectedValue = entityObject && entityObject[options.name];
    const [value, setValue] = useState(selectedValue || options?.selectedValue || "");
    const intl = useIntl();

    const onValueChange = ({ target: { name, value } }) => {
        setValue(value);
        onChange && onChange(name, value);
    };

    useEffect(() => {
        if (selectedValue !== value) {
            if (options?.selectedValue) {
                setValue(options?.selectedValue);
            } else {
                setValue(selectedValue);

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValue, options?.selectedValue]);

    return (
        <EuiFormRow
            fullWidth
            label={options.label}
            id={options.name}
            key={options.name}
            helpText={options.helpText}
            isInvalid={!_.isNil(errors[options.name])}
            error={options.errorMessage}
        >
            <EuiSelect
                fullWidth
                hasNoInitialSelection
                value={value}
                onChange={(e) => onValueChange(e)}
                name={options.name}
                options={options.data.map((d) => ({
                    value: d.value,
                    text: d.text,
                }))}
                inputRef={register({
                    ...options.validation,
                })}
                compressed={compressed}
                isLoading={isLoading}
                disabled={options.disabled}
            />
        </EuiFormRow>
    );
}

export default AbstractSelect;
